export function Background() {
  return <color attach="background" args={['#060612']} />;
}
